const Home = () => {
    return ( 
        <div style={{height: '70vh'}} >
            <h1 className="text-center">Welcome to Techbazaar Marketing !</h1>
        </div>
     );
}
 
export default Home;